@if (widgetInfo && widgetPanelCounts) {
  <div class="container-fluid">
    <div class="row">
      <app-display-counts-widget
        [widgetPanelCounts]="widgetPanelCounts"
        [title]="'Reviewing Vendors'"
      ></app-display-counts-widget>
    </div>
  </div>
}
